export const SUPPLIERS_PER_PAGE = 10;
export const COMPANIES_PER_PAGE = 10;
